import comp from '../components/barrel';
import validator from 'validator';

export default {
  async prepare() {},
  async render() {
    const rec = this.recipe.methods;
    let data = {};
    if (rec.length) {
      data = await O.PREP(rec);
    }
    await this.loadPage(data);
  },
  async loadPage(data) {
    const querySearchString = window.location.search;
    const urlParams = new URLSearchParams(querySearchString);
    const token_key = urlParams.get('token_key');
    if (token_key) {
      await U.createCookie('tokdcbsll', token_key);
      U.hide('loginPage');
      U.unhide('resetPage');
    }
    window.addEventListener('keyup', thsPage.onEnter);
  },
  async login() {
    U.loaderBtn(1, 'loginBtn');
    const vars = {};
    vars.email_address = U.id('username').value;
    vars.userpass = U.id('password').value;

    await O.PREP([await O.mPOST('login/login', vars)])
      .then(async (res) => {
        const data = res['login/login'].data;

        U.loaderBtn(0, 'loginBtn');
        window.removeEventListener('keyup', thsPage.onEnter);
        // Set cookies
        const language_id = data.language_id ? data.language_id : 1;
        const {user_uuid, token, refreshToken, default_open_applications_yn, autofill_id_yn, white_label, allow_invite_client_fulfillment} = data;
        await O.initSession({
          user_uuid,
          token,
          refreshToken,
          language_id,
          default_open_applications_yn,
          autofill_id_yn,
          white_label: white_label ?? null,
          allow_invite_client_fulfillment: allow_invite_client_fulfillment ?? false,
        });

        await O.bootstrapAuthenticatedApp();
        const directUuid = O.getDirectApplicationUuid();
        if (directUuid) {
          await O.navigateToDirectApplication(directUuid);
          O.clearDirectApplicationParam();
        } else {
          await O.PREP('HomePage');
        }
        await U.getCommunalDropdowns();
        
      })
      .catch((err) => {
        //Errorbox here
        U.loaderBtn(0, 'loginBtn');
      });
  },
  async onEnter(e){
    if (e.key === 'Enter') {
      thsPage.login();
    }
  },
  async forgotPass() {
    const emailInput = U.id('emailReset');
    const emailValue = emailInput.value.trim();
    
    // Clear previous error styling
    emailInput.classList.remove('input-error');
    const feedbackElement = document.querySelector('[fb-for="emailReset"]');
    if (feedbackElement) {
      feedbackElement.textContent = '';
    }
    
    // Validate email field
    if (!emailValue) {
      emailInput.classList.add('input-error');
      if (feedbackElement) {
        feedbackElement.textContent = 'Email address is required';
      }
      comp.toast_v2({msg: 'Please enter your email address', state: 2});
      return;
    }
    
    if (!validator.isEmail(emailValue)) {
      emailInput.classList.add('input-error');
      if (feedbackElement) {
        feedbackElement.textContent = 'Please enter a valid email address';
      }
      comp.toast_v2({msg: 'Please enter a valid email address', state: 2});
      return;
    }
    
    U.loaderBtn(1, 'forgotPassBtn');
    const vars = {};
    vars.email_address = emailValue;

    await O.PREP([await O.mPOST('login/forgot-password', vars)]).then((res) => {
      const response = res['login/forgot-password'];
      
      // Check for errors
      if (response.status === 'FAILED' || response.error || (response.data && response.data.error)) {
        const errorMsg = response.error || (response.data && response.data.error) || 'Failed to reset password. Please try again.';
        comp.toast_v2({msg: errorMsg, state: 2});
        U.loaderBtn(0, 'forgotPassBtn');
        return;
      }
      
      // Success case
      const msg = `${response.status}<br>Please check your email inbox for the reset link.`;
      comp.toast(msg);
      const onclick = "O.PREP('Login')";
      comp.modal('Password reset', msg, onclick);

      U.loaderBtn(0, 'forgotPassBtn');
    }).catch((err) => {
      // Error already handled by handleFetchError, just stop the loader
      U.loaderBtn(0, 'forgotPassBtn');
    });
  },
  async updatePass() {
    if (!U.id('password').value) {
      return alert('No password');
    }

    const {value} = await O.getCookie('tokdcbsll');
    const vars = {};
    vars.token_key = value;
    vars.userpass = U.id('password').value;

    await O.PREP([await O.mPOST('login/update-password', vars)]).then((res) => {

      const msg = res['login/update-password'].status;
      comp.toast(msg);

      document.cookie = `tokdcbsll=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    });
  },
  showForgot() {
    U.hide('loginDiv');
    U.unhide('passDiv');
  },
  showLogin() {
    U.unhide('loginDiv');
    U.hide('passDiv');
  },
};
